export const translations = {
  ar: {
    store_name: "الثقة",
    tagline: "من إسطنبول إلى الخليج",
    hero_title: "أصالة تركية… بجودة تستحق ثقتك",
    hero_sub: "نجمع لك أفخر المنتجات التركية من قلب إسطنبول ونشحنها إلى بيتك في الخليج بشحنة واحدة موحّدة.",
    shop_now: "تسوّق الآن",
    view_categories: "استكشف الأقسام",
    categories: "الأقسام",
    featured: "المنتجات المميزة",
    all_products: "كل المنتجات",
    search: "ابحث عن منتج...",
    add_to_cart: "أضف إلى السلة",
    cart: "السلة",
    empty_cart: "السلة فارغة",
    checkout: "إتمام الشراء",
    subtotal: "المجموع الفرعي",
    customs: "الجمارك",
    tax: "الضريبة",
    shipping: "الشحن السريع",
    total: "الإجمالي",
    consolidate: "تجميع الشحنة في طرد واحد",
    consolidate_hint: "وفّر تكاليف الشحن ووقت التوصيل بتجميع كل طلباتك في شحنة واحدة",
    login: "دخول",
    register: "تسجيل",
    logout: "خروج",
    email: "البريد الإلكتروني",
    password: "كلمة المرور",
    name: "الاسم الكامل",
    phone: "رقم الهاتف",
    address: "العنوان",
    country: "الدولة",
    city: "المدينة",
    orders: "طلباتي",
    admin_dashboard: "لوحة التحكم",
    products_admin: "إدارة المنتجات",
    orders_admin: "إدارة الطلبات",
    reviews: "التقييمات",
    write_review: "أضف تقييمك",
    rating: "التقييم",
    comment: "تعليقك",
    submit: "إرسال",
    payment_method: "طريقة الدفع",
    pay_mada: "بطاقة مدى",
    pay_apple: "أبل باي",
    pay_card: "بطاقة ائتمان",
    pay_cod: "الدفع عند الاستلام",
    place_order: "تأكيد الطلب",
    order_success: "تم استلام طلبك بنجاح",
    order_id: "رقم الطلب",
    status: "الحالة",
    quantity: "الكمية",
    remove: "حذف",
    continue_shopping: "متابعة التسوق",
    contact_whatsapp: "تواصل واتساب",
    language: "اللغة",
    currency: "العملة",
    from_istanbul: "شحن مباشر من إسطنبول",
    secure_pay: "دفع آمن ومشفّر",
    fast_ship: "شحن سريع للخليج",
    customer_reviews: "آراء العملاء",
    no_reviews: "لا توجد تقييمات بعد. كن أول من يقيّم!",
    footer_about: "الثقة – متجرك التركي الأصيل في إسطنبول. نوصل إليك أفخر المنتجات إلى دول الخليج.",
    all_rights: "جميع الحقوق محفوظة",
    stats_products: "المنتجات",
    stats_orders: "الطلبات",
    stats_customers: "العملاء",
    stats_revenue: "الإيرادات",
    save_product: "حفظ المنتج",
    edit: "تعديل",
    delete: "حذف",
    close: "إغلاق",
    est_delivery: "التوصيل المتوقع: 3-7 أيام",
    home: "الرئيسية",
    products: "المنتجات",
    about_us: "من نحن",
  },
  en: {
    store_name: "Al-Thiqa",
    tagline: "From Istanbul to the Gulf",
    hero_title: "Turkish Authenticity, Quality You Trust",
    hero_sub: "We handpick the finest Turkish products from the heart of Istanbul and ship them to your doorstep in the Gulf — consolidated into one parcel.",
    shop_now: "Shop Now",
    view_categories: "Browse Categories",
    categories: "Categories",
    featured: "Featured Products",
    all_products: "All Products",
    search: "Search products...",
    add_to_cart: "Add to Cart",
    cart: "Cart",
    empty_cart: "Your cart is empty",
    checkout: "Checkout",
    subtotal: "Subtotal",
    customs: "Customs",
    tax: "Tax / VAT",
    shipping: "Express Shipping",
    total: "Total",
    consolidate: "Consolidate into one parcel",
    consolidate_hint: "Save on shipping cost and time by combining all your items into a single package.",
    login: "Login",
    register: "Register",
    logout: "Logout",
    email: "Email",
    password: "Password",
    name: "Full Name",
    phone: "Phone Number",
    address: "Address",
    country: "Country",
    city: "City",
    orders: "My Orders",
    admin_dashboard: "Admin Dashboard",
    products_admin: "Manage Products",
    orders_admin: "Manage Orders",
    reviews: "Reviews",
    write_review: "Write a Review",
    rating: "Rating",
    comment: "Your comment",
    submit: "Submit",
    payment_method: "Payment Method",
    pay_mada: "Mada Card",
    pay_apple: "Apple Pay",
    pay_card: "Credit Card",
    pay_cod: "Cash on Delivery",
    place_order: "Place Order",
    order_success: "Your order has been placed successfully",
    order_id: "Order ID",
    status: "Status",
    quantity: "Quantity",
    remove: "Remove",
    continue_shopping: "Continue Shopping",
    contact_whatsapp: "WhatsApp Us",
    language: "Language",
    currency: "Currency",
    from_istanbul: "Direct from Istanbul",
    secure_pay: "Secure & Encrypted Payments",
    fast_ship: "Fast Gulf Delivery",
    customer_reviews: "Customer Reviews",
    no_reviews: "No reviews yet. Be the first to review!",
    footer_about: "Al-Thiqa — your authentic Turkish store in Istanbul, shipping across the Gulf.",
    all_rights: "All rights reserved",
    stats_products: "Products",
    stats_orders: "Orders",
    stats_customers: "Customers",
    stats_revenue: "Revenue",
    save_product: "Save Product",
    edit: "Edit",
    delete: "Delete",
    close: "Close",
    est_delivery: "Estimated delivery: 3-7 days",
    home: "Home",
    products: "Products",
    about_us: "About Us",
  },
};

export const t = (lang, key) => translations[lang]?.[key] ?? key;
